import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';
import { openConstructor } from '../AddCreativePage/actions';
import { CanvasEditorAction } from '../common/actions';
import { Order, Page } from '../common/typings';

import {
    applySizesFilter,
    deleteCreative,
    hideCreativesSelector,
    hideDeleteConfirm,
    hideError,
    loadItems,
    saveName,
    setSelection,
    showCreativesSelector,
    showDeleteConfirm,
    submit,
    submitSizesSelection,
    toggleSizesSelection
} from './actions';
import { CommonCreatives } from './CommonCreatives';
import { CommonCreativesProps, CommonCreativesState } from './typings';

type OwnProps = {
    cancel: () => void;
    creativesSelect: (ids: number[]) => void;
};
type DispatchProps = TDispatchProps<CommonCreativesProps, OwnProps>;
const mapDispatchToProps = (dispatch: Dispatch<CanvasEditorAction>, ownProps: OwnProps): DispatchProps => {
    return {
        loadItems: (offset: number, order: Order, sizes: string[]) => dispatch(loadItems(offset, order, sizes)),
        applySizesFilter: (sizes: string[]) => dispatch(applySizesFilter(sizes)),
        setSelection: (id: string, selected: boolean) => dispatch(setSelection(id, selected)),
        saveName: (id: string, val: string) => dispatch(saveName(id, val)),
        hideError: () => dispatch(hideError()),
        delete: () => dispatch(deleteCreative()),
        toggleSizesSelection: (ids: number[], selected: boolean) => dispatch(toggleSizesSelection(ids, selected)),
        submitSizesSelection: () => dispatch(submitSizesSelection()),
        showDeleteConfirm: (id: string) => dispatch(showDeleteConfirm(id)),
        hideDeleteConfirm: () => dispatch(hideDeleteConfirm()),
        submit: () => dispatch(submit(ownProps.creativesSelect)),
        showCreativesSelector: (id: string) => dispatch(showCreativesSelector(id)),
        createBatch: (id: string, isAdaptive?: boolean) =>
            dispatch(openConstructor(Page.CREATIVES, undefined, id, undefined, isAdaptive)),
        hideCreativesSelector: () => dispatch(hideCreativesSelector())
    };
};

type StateProps = TStateProps<CommonCreativesState>;
export const mapStateToProps = (state: State): StateProps => {
    return state.canvasEditor.canvas.commonCreatives;
};

const mergeProps = (stateProps: StateProps, dispatchProps: DispatchProps, ownProps: OwnProps): CommonCreativesProps => {
    const { creativesSelect, ...otherProps } = ownProps;

    return {
        ...stateProps,
        ...dispatchProps,
        ...otherProps
    };
};

export const CommonCreativesContainer = connect<StateProps, DispatchProps, OwnProps, CommonCreativesProps>(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(CommonCreatives);
